import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useToasts } from 'react-toast-notifications';
import { doUpdateGroup } from 'store/actionCreators/groups';

import { useGeneralGroupSettingsForm } from './form';

export const useGeneralGroupSettings = (group) => {
  const dispatch = useDispatch();
  const { addToast } = useToasts();
  const { t } = useTranslation();

  const { handleSubmit, ...form } = useGeneralGroupSettingsForm({
    name: group.name,
  });

  const onSuccess = () => {
    addToast(t('group.changeGroupNameSuccess'), {
      appearance: 'success',
      autoDismiss: true,
    });
  };

  const updateGroup = (data) => dispatch(doUpdateGroup(data));

  const onSubmit = handleSubmit((values) =>
    updateGroup({
      id: group.id,
      onSuccess,
      ...values,
    }),
  );

  return {
    onSubmit,
    ...form,
  };
};
